/** Алфавітне порівняня рядків для української локалі (категорії, правила тощо). */
export function compareNameUkStrings(aStr, bStr) {
    return String(aStr ?? "").localeCompare(String(bStr ?? ""), "uk", {
        sensitivity: "base",
    });
}

/** Копія масиву об’єктів, відсортована за полем name. */
export function sortObjectsByNameUk(items, nameKey = "name") {
    return [...(items || [])].sort((a, b) =>
        compareNameUkStrings(a?.[nameKey], b?.[nameKey])
    );
}
